import mapActions from "actions/map";
import { connect, generatedActions, viewDispatchToProps, viewStateToProps } from "helpers/redux";

export default function (Component) {
    const mapState = (state) => ({
        ...viewStateToProps(state),
        mapBid: state.map.data.currentBid,
    });
    const mapDispatch = (dispatch) => {
        return {
            ...viewDispatchToProps(dispatch),
            mergeParams: (params) => dispatch(generatedActions.bids.merge(params)),
            mergeMapData: (data) => dispatch(mapActions.mergeMapData(data)),
            mergeMapViewport: (data) => dispatch(mapActions.mergeMapViewport(data)),
        };
    };
    return connect(mapState, mapDispatch)(Component);
}
